
class TokenStore {
    static getToken(genre) {
        return localStorage.getItem(`${genre}_token`);
    }

    static setToken(genre, value) {
        return localStorage.setItem(`${genre}_token`, value);
    }

    static removeToken(genre) {
        return localStorage.removeItem(`${genre}_token`)
    }
}

export default TokenStore;